import { render } from "./DeviceRecordChart.vue?vue&type=template&id=4cdf76e4&ts=true"
import script from "./DeviceRecordChart.vue?vue&type=script&lang=ts"
export * from "./DeviceRecordChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__